import ThickText from "./ThickText";
import NormalText from "./NormalText";

const exportObjs = {
  Thick: ThickText,
  Normal: NormalText,
};

export default exportObjs;
